// ** I18n Imports
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// Generic handling for all domains
let urlGlobal = `https://global.${document.location.hostname}`
// Special case: localhost should point to dev environment
if (document.location.hostname === 'localhost' || document.location.hostname.endsWith('localhost')) {
  urlGlobal = 'https://global.dev.optimahr.dev'
}

function loadVocabulary() {
    const lang = localStorage.getItem("i18nextLng")
    const vocabularyLang = sessionStorage.getItem("language")
    if (lang !== vocabularyLang) {
        fetch(`${urlGlobal}/flatten/translation/${lang}`, {
          headers: {
           Authorization: "Bearer ".concat(JSON.parse(localStorage.getItem("accessToken"))),
           'Content-Type': 'application/x-www-form-urlencoded'
       }})
        .then((res) => res.json())
        .then((vocabulary) => {
            sessionStorage.setItem('vocabulary', JSON.stringify(vocabulary))
            sessionStorage.setItem('language', lang)
            sessionStorage.removeItem('clientvocabfr')
            sessionStorage.removeItem('clientvocaben')
        })
        .catch(function (err) {
            console.error(err)
        })
    }
}

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    initImmediate: false,
    lng: localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : 'fr-FR',
    interpolation: {
        escapeValue: false
    },
    backend: {
        loadPath: `${urlGlobal}/flatten/translation/{{lng}}`,
        crossDomain: true
    }
}, loadVocabulary)

import payTransparencyDe from '@src/views/optimize/pay-transparency/locales/pay-transparency-de.json'
import payTransparencyEn from '@src/views/optimize/pay-transparency/locales/pay-transparency-en.json'
import payTransparencyEs from '@src/views/optimize/pay-transparency/locales/pay-transparency-es.json'
import payTransparencyFr from '@src/views/optimize/pay-transparency/locales/pay-transparency-fr.json'
import payTransparencyNl from '@src/views/optimize/pay-transparency/locales/pay-transparency-nl.json'
import onboardingEn from './onboarding-en.json'
import onboardingFr from './onboarding-fr.json'

i18n.addResourceBundle('en-GB', 'translation', onboardingEn)
i18n.addResourceBundle('fr-FR', 'translation', onboardingFr)
i18n.addResourceBundle('en-GB', 'payTransparency', payTransparencyEn)
i18n.addResourceBundle('fr-FR', 'payTransparency', payTransparencyFr)
i18n.addResourceBundle('de-DE', 'payTransparency', payTransparencyDe)
i18n.addResourceBundle('es-ES', 'payTransparency', payTransparencyEs)
i18n.addResourceBundle('nl-NL', 'payTransparency', payTransparencyNl)

// ** Synchronise l'attribut lang du document avec la langue courante (RGAA 8.3/8.4)
const syncDocumentLang = lng => {
    const base = (lng || i18n.language || 'fr-FR').split('-')[0]
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = base
    }
}
syncDocumentLang(i18n.language)
i18n.on('languageChanged', syncDocumentLang)

export { loadVocabulary }
export default i18n
